"use strict";
export function thousandSeparatorFormat(input) {
  const cleanedInput = input.replace(/[^\d.]/g, "");
  const parts = cleanedInput.split(".");
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.length > 1 ? `${integerPart}.${parts[1]}` : integerPart;
}
